export default __webpack_public_path__ + "static/media/About-Business.3b8c3e51.svg";